import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class LightingFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_lightning_fixture';
    this.partName = 'Lighting Fixture';
    this.visible = [Vanity.Types.Complete, Vanity.Types.Custom];
  }

  setZIndex() {
    console.log('layout');
  }
}